import _ from 'underscore';

export type Status =
  | 'preparing'
  | 'executing'
  | 'complete'
  | 'failed'
  | 'cancelled'
  | 'complete_with_errors';

export type BulkAction = {
  id: number;
  name: string;
  status: Status;
  progress?: number;
  totalCount: number;
  failureCount?: number;
};

export function isUnresolved(bulkAction: BulkAction) {
  return bulkAction.status === 'executing' || bulkAction.status === 'preparing';
}

export function isResolved(bulkAction: BulkAction) {
  return !isUnresolved(bulkAction);
}

export function isDismissed(bulkAction: BulkAction, dismissed: Array<number>) {
  return dismissed.some((id) => bulkAction.id === id);
}

export function anyUnresolved(bulkActions: Array<BulkAction>) {
  return bulkActions.some((bulkAction) => isUnresolved(bulkAction));
}

export function allAcknowledged(
  bulkActions: Array<BulkAction>,
  acknowledged: Array<number>
) {
  return (
    _.difference(
      bulkActions.map((bulkAction) => bulkAction.id),
      acknowledged
    ).length === 0
  );
}
